import React from "react";
import Skeleton from "../shared/skeleton-component";

const DropOffModalSkeleton = () => {
  return (
    <div>
        <div className="ob-modal-title">
      <Skeleton width="100%" height="40px" />
        </div>
      <div className="ob-modal-content-wrapper">
        <div className="ob-modal-subtitle">
      <Skeleton width="100%" height="40px" mobWidth="70vw" />
        </div>
      <div className="ob-modal-active-number">
      <Skeleton width="360px" height="78px" mobWidth="80vw" />
      </div>
      <div className="stm-sum-wrapper">
      <Skeleton width="100%" height="121px" mobWidth="70vw" />
      </div>
      <div className="ob-modal-action-button">
      <Skeleton width="267px" height="56px" mobWidth="70vw" />
      <Skeleton width="267px" height="56px" />
      </div>
      </div>
    </div>
  );
};

export default DropOffModalSkeleton;
